import Constants from '../DataManagement/Constants';

const initialState = {
  markers: [
    { x: 0, y: 0, height: 0, width: 0, pageX: 0, pageY: 0, id: -1 },
    { x: 0, y: 0, height: 0, width: 0, pageX: 0, pageY: 0, id: -1 },
    { x: 0, y: 0, height: 0, width: 0, pageX: 0, pageY: 0, id: -1 },
  ],
  markersVisible: true,
};
/**
 * Stores position information for the Position markers
 * @param {*} state
 * @param {*} action
 */
const positionMarkersReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }
  switch (action.type) {
    case Constants.REDUX_ACTIONS.UPDATE_MARKER: {
      const markers = [];

      // Build return object
      for (let i = 0; i < state.markers.length; i++) {
        if (i === action.payload.id) {
          markers.push({
            ...state.markers[i],
            x: action.payload.x,
            y: action.payload.y,
            height: action.payload.height,
            width: action.payload.width,
            pageX: action.payload.pageX,
            pageY: action.payload.pageY,
            id: action.payload.id,
          });
        } else {
          markers.push({ ...state.markers[i] });
        }
      }

      return {
        ...state,
        markers,
      };
    }
    case Constants.REDUX_ACTIONS.UPDATE_MARKER_VISIBILITY: {
      return {
        ...state,
        markersVisible: action.payload,
      };
    }

    case Constants.REDUX_ACTIONS.RESET_POSITION_MARKERS_TO_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};

export default positionMarkersReducer;
